import { useMutation } from 'react-query';
import { AnchorAPI } from 'client/modules/AnchorAPI';

export function useUpdateUserLocale() {
  const { mutate, status } = useMutation(
    ({ userId, locale }: { userId: number; locale: string }) => {
      if (!userId || !locale) {
        return Promise.reject(
          new Error(
            'userId and locale are required parameters to update the user locale.'
          )
        );
      }
      return AnchorAPI.updateUserLocale({ userId, locale });
    },
    { retry: 2 }
  );

  return { updateUserLocale: mutate, status };
}
